import { apiClient } from "@/lib/api/client";

export type WorkspaceEntitlementPolicyDto = {
  id: string;
  tenant_id: string;
  default_warranty_months: number;
  post_expiry_read_days: number;
  ingest_after_expiry: boolean;
  block_explorer_after_expiry: boolean;
  block_analytics_after_expiry: boolean;
  block_live_after_expiry: boolean;
  stop_reports_after_expiry: boolean;
  stop_alerts_after_expiry: boolean;
  allow_device_override: boolean;
  created_at: string;
  updated_at: string;
};

export type WorkspaceEntitlementPolicyUpdateBody = Partial<
  Pick<
    WorkspaceEntitlementPolicyDto,
    | "default_warranty_months"
    | "post_expiry_read_days"
    | "ingest_after_expiry"
    | "block_explorer_after_expiry"
    | "block_analytics_after_expiry"
    | "block_live_after_expiry"
    | "stop_reports_after_expiry"
    | "stop_alerts_after_expiry"
    | "allow_device_override"
  >
>;

export async function getWorkspaceEntitlementPolicy(
  tenantId?: string | null,
): Promise<WorkspaceEntitlementPolicyDto> {
  const { data } = await apiClient.get<WorkspaceEntitlementPolicyDto>("/entitlements/workspace", {
    params: tenantId ? { tenant_id: tenantId } : undefined,
  });
  return data;
}

export async function updateWorkspaceEntitlementPolicy(
  body: WorkspaceEntitlementPolicyUpdateBody,
  tenantId?: string | null,
): Promise<WorkspaceEntitlementPolicyDto> {
  const { data } = await apiClient.put<WorkspaceEntitlementPolicyDto>("/entitlements/workspace", body, {
    params: tenantId ? { tenant_id: tenantId } : undefined,
  });
  return data;
}
